import React from "react";
import { motion } from "framer-motion";

const rows = [
  {
    name: "6-month contract term",
    detail:
      "Required for the discounted pricing in this quote. Locks in the per-location rate for the duration of the term.",
    value: "6 months",
    note: "Term length",
  },
  {
    name: "Complimentary support",
    detail:
      "Ongoing support across the full Asha platform — included at no additional cost throughout the engagement.",
    value: "Included",
    note: "$0 / month",
  },
];

const AshaAbrahamContractTermsSlide = () => {
  return (
    <div className="h-full w-full bg-[#f8fafc] flex items-center justify-center p-6 xl:p-10 relative overflow-hidden font-sans">
      {/* Ambient gradient blurs */}
      <div
        className="absolute top-[-200px] right-[-100px] w-[700px] h-[700px] rounded-full blur-[120px] opacity-25 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #93c5fd 0%, #c4b5fd 50%, #fbcfe8 100%)" }}
      />
      <div
        className="absolute bottom-[-200px] left-[-100px] w-[600px] h-[600px] rounded-full blur-[120px] opacity-20 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #a5f3fc 0%, #93c5fd 50%, #c4b5fd 100%)" }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(#cbd5e1_0.8px,transparent_0.8px)] [background-size:28px_28px] opacity-40 pointer-events-none" />

      <div className="w-full max-w-[1040px] z-10 relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <h2 className="text-3xl lg:text-[40px] font-bold text-slate-900 tracking-tight leading-tight">
            Contract{" "}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              terms.
            </span>
          </h2>
          <p className="text-[14px] text-slate-600 mt-2">
            Simple, transparent terms for the Abraham Dental partnership.
          </p>
        </motion.div>

        {/* Terms table */}
        <motion.table
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="w-full"
        >
          <thead>
            <tr className="border-t border-b border-slate-200">
              <th className="text-left py-3 pr-8 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
                Term
              </th>
              <th className="text-right py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500 w-[240px]">
                Detail
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.name} className="border-b border-slate-200 align-top">
                <td className="py-5 pr-8">
                  <div className="text-[16px] font-semibold text-slate-900 leading-snug">
                    {row.name}
                  </div>
                  <div className="text-[13px] text-slate-500 leading-relaxed mt-1.5 max-w-[700px]">
                    {row.detail}
                  </div>
                </td>
                <td className="py-5 text-right whitespace-nowrap">
                  <div className="text-[20px] font-semibold text-slate-900 leading-none tracking-tight">
                    {row.value}
                  </div>
                  <div className="text-[12px] text-slate-500 mt-1.5">
                    {row.note}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </motion.table>
      </div>
    </div>
  );
};

export default AshaAbrahamContractTermsSlide;
